import React from 'react'

export default function Tab({ id, children }) {
  return <div id={id}>{children}</div>
}
